import { SVGProps } from 'react';

const ClockArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 6v6l1.56.78m-.333 9.145a10 10 0 1 1 8.767-9.588M22 18l-4-4-4 4m4-4v8"
    />
  </svg>
);
export default ClockArrowUp;
